import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../button';
import {UndrawTabs,UndrawBrainstorming,UndrawEatingTogether,UndrawGrowing, UndrawHouseSearching,UndrawResponsive, UndrawCoworkers, UndrawExperts} from 'react-undraw-illustrations';


import '../content-section.css';

const red = '#fc5e5f'

const SectionOne = ({authenticated, signOut}) => (
	<div>
		<div className="container">
			<h2 style={{fontWeight:'600', color:'#555'}}>A list of verified people</h2>
			<p style={{fontSize:'18px'}}>Find trustworthy makers to live and build with.</p>
		</div>
		<div className="container" style={{paddingBottom:'50px'}}>
			<div className="steps__inner">
				<div className="step">
					<div className="step__media">
					<div  style={{margin:'0 auto', maxWidth:'250px',  maxHeight:'150px', paddingTop:'15px'}}>
						<UndrawBrainstorming 
								primaryColor='#07A4B5'
								accentColor='#C9EFF9'
								secondaryColor="orange"
								height='175px'
							/>
						</div>					
					</div>
					<h3>Don't be lonely</h3>
					<p className="step__text" style={{textAlign:'center', fontSize:'16px'}}>Remote life can get lonely - work alongside eachother and never be isolated.</p>
				</div>
				<div className="step">
					<div className="step__media">
					<div  style={{margin:'0 auto', maxWidth:'250px', maxHeight:'150px'}}>
						<UndrawEatingTogether 
							primaryColor='#07A4B5'
							accentColor='#FED8A7'
							skinColor="#e0b184"
							height='175px'
						/>
						</div>
					</div>
					<h3>Meet people you'll like</h3>
					<p className="step__text" style={{textAlign:'center', fontSize:'16px'}}>Take the quiz and find people you're more likely to get along with. </p>
				</div>
				<div className="step">
					<div className="step__media">
						<div  style={{margin:'0 auto', maxWidth:'250px', maxHeight:'150px'}}>
							<UndrawGrowing 
								primaryColor='#07A4B5'
								accentColor='#07A4B5'
								skinColor="#710200"
								secondaryColor="#FED8A7"
								height='175px'
							/>
						</div>
					</div>
					<h3>Progress together</h3>
					<p className="step__text" style={{textAlign:'center', fontSize:'16px'}}>Make friends for life through the act of building things together.</p>
				</div>
			</div>
		</div>
	</div>
);


export default SectionOne;



// WEBPACK FOOTER //
// ./src/views/components/content-section/templates/section-one.js